export default {
  id: 'gruas-monterrey',
  displayName: 'Gruas Monterrey',
  topbarColor: '#ffc434',
  topbarLogo: require('@/assets/logogruas.png'),
}
